import ACTIONS from "../actions";

export default function clinicsReducer(state, action) {
  switch (action.type) {
    case ACTIONS.GET_ALL_CLINICS:
      return {
        ...state,
        allClinics: action.payload
      };
    case ACTIONS.DELETE_CLINIC:
      return {
        ...state,
        allClinics: action.payload
      };
    case ACTIONS.CREATE_CLINIC:
      const updatedClinics = [
          ...state.allClinics,
          action.payload
      ]
      const sortedClinics = updatedClinics.sort(function(a,b) {
        let clinicA = a.name;
        let clinicB = b.name
        return (clinicA < clinicB ? -1 : (clinicA > clinicB) ? 1 : 0)
      })
      return {
        ...state,
        allClinics: [
          ...sortedClinics
        ]
      };
    default: return state
  }

}